module.exports = __webpack_public_path__ + "img/rewardArrow.6ac6f9be.png";